/* Pluto cart drawer: plan under each item, renewal line that matches the
   plans in the cart, and subtotal plus discount lines above the total.
   Runs after the theme rebuilds the drawer (theme.miniCart.generateCart). */
(function () {
  if (window.__plutoCartUi) return;
  window.__plutoCartUi = true;

  function money(cents) {
    try { if (window.theme && theme.Currency && theme.moneyFormat) return theme.Currency.formatMoney(cents, theme.moneyFormat); } catch (e) {}
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function planName(item) {
    var a = item && item.selling_plan_allocation;
    return a && a.selling_plan ? String(a.selling_plan.name || '') : '';
  }
  function cadence(name) {
    var n = name.toLowerCase();
    if (/90[\s-]?day|quarter|3[\s-]?month/.test(n)) return 90;
    if (/30[\s-]?day|month/.test(n)) return 30;
    return 0;
  }
  function planLabel(item) {
    var name = planName(item); if (!name) return '';
    var c = cadence(name);
    var supply = name.replace(/\s*\([^)]*\)\s*/g, ' ').replace(/[.,]\s*$/, '').trim();
    if (c === 90) return supply + ', renews every 90 days';
    if (c === 30) return supply + ', renews monthly';
    return supply;
  }
  function renewSentence(items) {
    var seen = {};
    items.forEach(function (it) { var c = cadence(planName(it)); if (c) seen[c] = true; });
    var keys = Object.keys(seen);
    if (!keys.length) return '';
    if (keys.length > 1) return 'Each item renews on its own plan, pause or cancel anytime. ';
    return (keys[0] === '90' ? 'Renews every 90 days' : 'Renews monthly') + ', pause or cancel anytime. ';
  }

  /* Round 21: money without trailing zeros, like the rest of the site ($345, $311.67) */
  function m2(cents) { var v = Math.round(cents) / 100; return '$' + (v % 1 === 0 ? String(v) : v.toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  /* the options as words: "Cotton Candy, 30mL, with oxytocin" instead of "Cotton Candy / 30mL / Yes" */
  function optLine(item) {
    var out = [];
    (item.options_with_values || []).forEach(function (o) {
      var n = String(o.name || ''), v = String(o.value || '');
      if (!v || /default title/i.test(v)) return;
      if (/oxytocin/i.test(n) && /^(yes|no)$/i.test(v)) { out.push(/^yes$/i.test(v) ? 'with oxytocin' : 'no oxytocin'); return; }
      out.push(v);
    });
    var s = out.join(', ');
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : '';
  }
  function cleanTitle(t) { return String(t || '').replace(/\s+[\u2013\u2014]\s+/g, ', '); }
  function setOnce(el, cls, after, text, html) {
    var n = el.querySelector('.' + cls);
    if (!text && !html) { if (n) n.remove(); return null; }
    if (!n) { n = document.createElement('span'); n.className = cls; if (after && after.nextSibling) el.insertBefore(n, after.nextSibling); else el.appendChild(n); }
    if (html != null) { if (n.innerHTML !== html) n.innerHTML = html; } else if (n.textContent !== text) n.textContent = text;
    return n;
  }
  function paint(cart) {
    document.querySelectorAll('.js-mini-cart').forEach(function (root) {
      root.querySelectorAll('.mini-cart-item').forEach(function (row, i) {
        var item = cart.items[i]; var meta = row.querySelector('.mini-cart-meta'); if (!meta || !item) return;
        var titleBox = meta.firstElementChild, link = titleBox && titleBox.querySelector('a');
        if (link) { var t = cleanTitle(item.product_title); if (link.textContent !== t) link.textContent = t; }
        var opts = setOnce(meta, 'pl-opts', titleBox, optLine(item));
        var label = planLabel(item);
        var tag = setOnce(meta, 'pl-plan', opts || titleBox, label);
        /* the price as a monthly figure; the 90-day plan shows what it is a month and what is billed */
        var c = cadence(planName(item)), q = item.quantity || 1, unit = item.final_price, html;
        if (c === 90) html = '<b>' + m2(unit / 3) + '/mo</b><small>Billed ' + m2(item.final_line_price) + ' every 90 days' + (q > 1 ? ' (' + q + ' items)' : '') + '</small>';
        else if (c === 30) html = '<b>' + m2(unit) + '/mo</b>' + (q > 1 ? '<small>' + q + ' items, ' + m2(item.final_line_price) + ' a month</small>' : '');
        else html = '<b>' + m2(item.final_line_price) + '</b>' + (q > 1 ? '<small>' + q + ' items</small>' : '');
        setOnce(meta, 'pl-price', tag || opts || titleBox, null, html);
        /* hide the theme's "$935.00 x 1" line now that the price line says it */
        Array.prototype.slice.call(meta.childNodes).forEach(function (n) {
          if (n.nodeType === 3 && /^\s*x\s*\d+\s*$/.test(n.textContent)) n.textContent = '';
          if (n.nodeType === 1 && n.tagName === 'SPAN' && !n.className && /\$/.test(n.textContent)) n.style.display = 'none';
        });
      });

      var taxes = root.querySelector('.mini-cart-taxes');
      if (taxes) {
        var text = 'All in: your clinician visit, the pharmacy and free shipping are included. ' + renewSentence(cart.items) + 'Texas residents only.';
        if (taxes.textContent.trim() !== text.trim()) taxes.textContent = text;
      }

      var total = root.querySelector('.mini-cart-total .bottom-total');
      if (total) {
        var box = root.querySelector('.pl-cart-lines');
        var lineDisc = 0; cart.items.forEach(function (it) { lineDisc += it.line_level_total_discount || 0; });
        var apps = cart.cart_level_discount_applications || [];
        if (!(cart.total_discount > 0)) { if (box) box.remove(); return; }
        if (!box) { box = document.createElement('div'); box.className = 'pl-cart-lines'; total.parentNode.insertBefore(box, total); }
        var html = '<div class="pl-cart-line"><span>Subtotal</span><span>' + money(cart.original_total_price) + '</span></div>';
        if (lineDisc > 0) html += '<div class="pl-cart-line pl-cart-line--discount"><span>Item discounts</span><span>-' + money(lineDisc) + '</span></div>';
        apps.forEach(function (d) {
          if (d.total_allocated_amount > 0) html += '<div class="pl-cart-line pl-cart-line--discount"><span>' + esc(d.title) + '</span><span>-' + money(d.total_allocated_amount) + '</span></div>';
        });
        if (box.innerHTML !== html) box.innerHTML = html;
      }
    });
  }

  var timer = null, inflight = false, queued = false;
  function refresh() {
    if (inflight) { queued = true; return; }
    inflight = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(paint)
      .catch(function () {})
      .then(function () { inflight = false; if (queued) { queued = false; refresh(); } });
  }
  function soon() { clearTimeout(timer); timer = setTimeout(refresh, 80); }

  function watch() {
    document.querySelectorAll('.js-mini-cart-content').forEach(function (el) {
      if (el.__plWatch) return; el.__plWatch = true;
      new MutationObserver(soon).observe(el, { childList: true });
    });
    soon();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  window.plutoCartUiRefresh = refresh;
})();
